import React, { lazy } from 'react';
import { Route, Routes } from 'react-router';

import DashboardLayout from './Layout/DashboardLayout';
const HomePage = lazy(() => import('./Home/HomePage'));

const CreateAccount = lazy(() => import('./CreateAccount/CreateAccount'));
const ForgotUserIdComponent = lazy(() => import('./Login/ForgotUserId'));
const FAQ = lazy(() => import('./FAQs/FAQs'));
const NotFound = lazy(() => import('../../Common/components/NotFound/NotFound'));
const Error = lazy(() => import('../../Common/components/Error/Error'));
const App = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<DashboardLayout />}>
          <Route index element={<HomePage />} />
          <Route path="/register" element={<CreateAccount />} />
          <Route path="/forgot-userId" element={<ForgotUserIdComponent />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/error" element={<Error />} />
          <Route path="/notfound" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </div>
  );
};

export default App;
